export default {
  openKeys: [],
  selectedKeys: ['Dashboard'],
  views: [],
  viewsAlive: [],
  viewsShow: null,
  privateState: {},
  sharedState: {}
}